import { render, staticRenderFns } from "./CertificateTable.vue?vue&type=template&id=d22e0564&scoped=true"
import script from "./CertificateTable.vue?vue&type=script&lang=js"
export * from "./CertificateTable.vue?vue&type=script&lang=js"
import style0 from "./CertificateTable.vue?vue&type=style&index=0&id=d22e0564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22e0564",
  null
  
)

export default component.exports